(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-ap-func-callback', actionFunc);

    function actionFunc($q, lodash, PanelManager) {
        return function (panel, options) {
            const panel_id_override = lodash.get(options, 'panel_id', null);
            const funcName = lodash.get(options, 'funcName', 'getModel');
            const pathToFun = lodash.get(options, 'pathToFunc', null);
            const targetted_panel = (panel_id_override) ? PanelManager.get(panel_id_override) : panel;

            var callbackFunc = null;

            if (pathToFun) {
                const parent = lodash.get(targetted_panel, pathToFun);
                callbackFunc = parent[funcName];
            } else {
                callbackFunc = targetted_panel[funcName];
            }
            console.log(targetted_panel);

            if (typeof callbackFunc === typeof function() {}) {
                callbackFunc();
            }
        }
    }
})();